export const StringService = {
  isEmpty(stringToTest) {
    if (stringToTest.length == 0) {
      return true;
    } else {
      return false;
    }
  },
  formatAmount(plainAmount) {
    var amount = plainAmount / 100;
    return amount.toFixed(2);
  },
  numberFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  },
  getLastUpdateDayAndMonth(timestamp_to_format) {
    var lastUpdateDayAndMonth = "";
    if (timestamp_to_format) {
      timestamp_to_format = timestamp_to_format.replace(/-/g, "/");
      var dateLastUpdate = new Date(timestamp_to_format);

      lastUpdateDayAndMonth = dateLastUpdate.getDay() + " " + this.getMonthAbbr(dateLastUpdate.getMonth() + 1);

      lastUpdateDayAndMonth;
    }

    return lastUpdateDayAndMonth;
  },
  getMonthAbbr(month) {
    switch (month) {
      case 1:
        return "janvier";
      case 2:
        return "février";
      case 3:
        return "mars";
      case 4:
        return "avril";
      case 5:
        return "mai";
      case 6:
        return "juin";
      case 7:
        return "juillet";
      case 8:
        return "août";
      case 9:
        return "septembre";
      case 10:
        return "octobre";
      case 11:
        return "novembre";
      case 12:
        return "décembre";

      default:
        return "";
    }
  },
  /**
   * Format a portage value with correct French pluralization.
   * Accepts plain numbers ("0", "1", "2") and ranges ("0-2", "1-2").
   * "0" and "1" are singular in French; 2+ and any range are plural.
   *
   * @param {string|number|null|undefined} portage
   * @returns {string}  e.g. "0 portage", "1 portage", "2 portages", "0-2 portages"
   */
  formatPortage(portage) {
    if (portage === undefined || portage === null) {
      return "";
    }
    const val = String(portage).trim();
    if (val === "") {
      return "";
    }
    return `${val} portage${val === "0" || val === "1" ? "" : "s"}`;
  },
  /**
   * Build a short summary string combining a cotation and its portage count.
   * Returns e.g. "R4 | 0-2 portages" or just "R4" when portage is empty.
   *
   * @param {string} cotation  e.g. "R4"
   * @param {string|number} portage  e.g. "0-2"
   * @returns {string}
   */
  formatCotationSummary(cotation, portage) {
    const parts = [];
    if (cotation) {
      parts.push(cotation);
    }
    const portageStr = this.formatPortage(portage);
    if (portageStr) {
      parts.push(portageStr);
    }
    return parts.join(" | ");
  },
};
